module.exports = __webpack_public_path__ + "img/brand-nodejs.6ea46d26.svg";